import styled from 'styled-components';

import SelectTippy, { SelectTippyProps } from '../Tippy/SelectTippy';
import clsx from 'clsx';

const Label = styled.div<{ disabled?: boolean; marginBottom?: number }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 23px;
  color: var(--gray-700);
  margin-bottom: ${({ marginBottom = 8 }) => marginBottom}px;
  ${({ disabled }) => (disabled ? `color:var(--neutral-6)` : `color:var(--gray-700)`)}
`;
interface Props extends SelectTippyProps {
  label?: string;
  rootClass?: string;
  extraLabelClass?: string;
  isRequired?: boolean;
  isDisable?: boolean;
  labelMarginBottom?: number;
  styleRoot?: React.CSSProperties;
  styleSelectBody?: React.CSSProperties;
}
const FormSelect: React.FC<Props> = ({
  label,
  rootClass,
  extraLabelClass = '',
  isRequired = false,
  isDisable,
  labelMarginBottom,
  styleRoot,
  styleSelectBody,
  ...propSelect
}) => {
  return (
    <div
      className={clsx('fv-row', rootClass)}
      style={{
        marginBottom: 24,
        ...styleRoot,
      }}
    >
      {label && (
        <Label
          disabled={isDisable}
          marginBottom={labelMarginBottom}
          className={clsx(isRequired ? 'required' : '', extraLabelClass)}
        >
          {label}
        </Label>
      )}
      <SelectTippy {...propSelect} isDisable={isDisable} styleSelectBody={styleSelectBody} />
    </div>
  );
};

export { FormSelect };
